import { NotificationService } from './../../services/notification.service';
import { CommonAuthenticationService } from './../../services/common-authentication.service';
import { CommonRequestResponseService } from './../../services/common-request-response.service';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonDataSharedService } from 'app/services';
import { ConfirmModalService } from '../shared/confirm-modal/confirm-modal.service';
import 'chartjs-plugin-datalabels';
import { DraggableModalService } from '../shared/draggable-modal/draggable-modal.service';

interface GraphType {
  name?: string;
  value?: number;
}

// TODO: This component name is misspelled.
@Component({
  selector: 'app-assesment',
  templateUrl: './assesment.component.html',
  styleUrls: ['./assesment.component.scss'],
})
export class AssesmentComponent implements OnInit, OnDestroy {
  @Input() dynamicStudentUserId = '0';
  @Input() studentPartnerId;
  @Input() dynamicStudentProfileId;
  role: string;
  isTestCompleted: boolean;
  questions = [];
  selected1;
  startIndex;
  totalQuestions;
  endIndex;
  saveAnswers = [];
  nextButton: boolean;
  pageNumber: number;
  totalPages: number;
  webprofileanswerData;
  realistic;
  social;
  artistic;
  investigative;
  loader = false;
  localUserData;
  enterprising;
  conventional;
  resultCount = 6;
  yourCareerAssessmentResult: any[];
  chartDataLabels: any[] = [];
  chartDataValues: any[] = [];
  bar_chart: any;
  options: any;
  errorText: string;
  currentRoute;
  hideAssessment;
  yourTopIntersets;
  isTiedCondition;
  careerTabSelectUnsubscribe;
  careerTabSubmitUnsubscribe;
  isWebinarReservation;
  constructor(
    private _commonRequestResponseService: CommonRequestResponseService,
    private _commonAuthService: CommonAuthenticationService,
    private notificationService: NotificationService,
    private routes: ActivatedRoute,
    private commonDataSharedService: CommonDataSharedService,
    private confirmModalService: ConfirmModalService,
    private router: Router,
    private draggableModalService: DraggableModalService
  ) {
    this.role = this._commonAuthService.getModule().toLowerCase();
  }

  ngOnInit() {
    this.commonDataSharedService.careerAssessmentApiCall.subscribe(() => {
      this.getQuestions();
    });
    this.careerTabSubmitUnsubscribe = this.commonDataSharedService.careerTabSubmit.subscribe(() => {
      this.getQuestions(1);
    });
    this.getQuestions();

    this.localUserData = JSON.parse(localStorage.getItem('loginUserData'));
    if (this.localUserData.module.toLowerCase() === 'student') {
      this.hideAssessment = this.localUserData.hideAssessment;
      this.isWebinarReservation = this.localUserData.isWebinarReservation;
    } else {
      this.hideAssessment = JSON.parse(
        localStorage.getItem('studentHideAssessment')
      );
      this.isWebinarReservation = JSON.parse(
        localStorage.getItem('isWebinarReservation')
      );
    }
    this.currentRoute = this.routes.snapshot.url[0].path;

    this.careerTabSelectUnsubscribe = this.commonDataSharedService.studentCareerSelect.subscribe((item) => {
      this.getQuestions(item)
    })
  }
  getCareer() {
    const inputJson = {
      userId: this._commonAuthService.getUserId(),
      studentuserid: this.dynamicStudentUserId,
      partnerId: this.studentPartnerId,
    };
    this._commonRequestResponseService
      .postWithHeader('shared/youscience', inputJson)
      .subscribe(
        (careereAssessmentJson: any) => {
          window.open(careereAssessmentJson.url);
        },
        () => {
          this.notificationService.show(
            'error',
            'Error while fetching career assessment data'
          );
        }
      );
  }

  getPersonality() {
    const inputJson: any = {
      productId: '104',
      contextUserId: this.dynamicStudentUserId,
      partnerId: this.studentPartnerId,
    };

    if (this.role === 'student') {
      inputJson.userId = this.dynamicStudentUserId;
    }

    if (this.role === 'coach') {
      inputJson.partnerId = this.studentPartnerId;
    }
    this._commonRequestResponseService
      .postWithHeader('shared/HumanEsource', inputJson, ['partnerId'])
      .subscribe(
        (personalityAssessmentJson: any) => {
          window.open(personalityAssessmentJson.url);
        },
        (error) => {
          if (error && error.error && error.error.errorMessage) {
            this.notificationService.show('error', error.error.errorMessage);
          } else {
            this.notificationService.show(
              'error',
              'Error while fetching personality assessment data'
            );
          }
        }
      );
  }

  getLearning() {
    const inputJson: any = {
      productId: '101',
      contextUserId: this.dynamicStudentUserId,
      partnerId: this.studentPartnerId,
    };

    if (this.role === 'student') {
      inputJson.userId = this.dynamicStudentUserId;
    }

    if (this.role === 'coach') {
      inputJson.partnerId = this.studentPartnerId;
    }

    this._commonRequestResponseService
      .postWithHeader('shared/HumanEsource', inputJson, ['partnerId'])
      .subscribe(
        (learningAssessmentJson: any) => {
          const win = window.open(learningAssessmentJson['url'], '_blank');
          if (win) {
            win.focus();
          }
        },
        (error) => {
          if (error && error.error && error.error.errorMessage) {
            this.notificationService.show('error', error.error.errorMessage);
          } else {
            this.notificationService.show(
              'error',
              'Error while fetching learning assessment data'
            );
          }
        }
      );
  }

  getQuestions(tabSelectValue?) {
    const localUser = JSON.parse(localStorage.getItem('loginUserData'));
    this.loader = true;
    const inputJson = {
      StudentUserId: this.dynamicStudentUserId || localUser.userId,
    };
    this._commonRequestResponseService
      .postWithHeader('student/get/question', inputJson)
      .subscribe(
        (assessmentData: any) => {
          this.nextButton = false;
          this.isTestCompleted = assessmentData.isTestCompleted;
          this.loader = false;
          if (this.isTestCompleted) {
            this.webprofileanswer(tabSelectValue);
          }

          this.startIndex = 0;
          this.endIndex = 6;
          this.pageNumber = 1;

          this.totalQuestions = assessmentData.questions;
          this.totalPages = this.totalQuestions.length / 6;
          this.questions = this.totalQuestions.slice(
            this.startIndex,
            this.endIndex
          );
        },
        (err) => {
          this.loader = false;
        }
      );
  }
  nextQuestions() {
    if (this.saveAnswers.length === this.resultCount) {
      this.startIndex = this.endIndex;
      this.endIndex = this.endIndex + 6;
      this.pageNumber = this.pageNumber + 1;
      this.resultCount = this.resultCount + 6;
      this.questions = this.totalQuestions.slice(
        this.startIndex,
        this.endIndex
      );
      window.scroll(0, 300);
      if (this.pageNumber === this.totalPages) {
        this.nextButton = true;
      }
    } else {
      this.notificationService.show('error', 'Please answer all the questions');
    }
  }
  onSelectionChange(id, value, event) {
    const testDiv = document.createElement('div');
    testDiv.className = 'skewBG';
    const testSpan = document.createElement('span');
    testDiv.appendChild(testSpan);
    event.target.parentNode.append(testDiv);

    const elementsIndex = this.saveAnswers.findIndex(
      (element) => element.id === id
    );

    if (elementsIndex === -1) {
      this.saveAnswers.push({ id: id, answer: value });
    } else {
      this.saveAnswers[elementsIndex].answer = value;
    }
    const currentRoute = this.routes.snapshot.url[0].path;
    this.commonDataSharedService.questionModal.next({
      currentRoute: currentRoute,
      value: true,
    });
  }
  iamDone() {
    const localUser = JSON.parse(localStorage.getItem('loginUserData'));

    this.loader = true;
    const json = {
      StudentUserId: this.dynamicStudentUserId || localUser.userId,
      results: this.saveAnswers,
    };
    this._commonRequestResponseService
      .postWithHeader('student/save/webprofilequestion', json)
      .subscribe(
        (item: any) => {
          this.saveAnswers = [];
          this.resultCount = 6;
          this.commonDataSharedService.questionModal.next({
            currentRoute: '',
            value: false,
          });

          this.loader = false;
          this.getQuestions(1);
        },
        (err) => {
          this.loader = false;
        }
      );
  }

  webprofileanswer(tabSelectValue) {
    const localUser = JSON.parse(localStorage.getItem('loginUserData'));

    this.loader = true;
    const json = {
      StudentUserId: this.dynamicStudentUserId || localUser.userId,
      partnerId: this.studentPartnerId,
    };
    this._commonRequestResponseService
      .postWithHeader('student/get/webprofileanswer', json)
      .subscribe(
        (item: any) => {
          this.isTiedCondition = item.isTied;
          if (item && item.careerList) {
            this.webprofileanswerData = item.careerList;
          }
          if (item && item.yourTopIntersets) {
            this.yourTopIntersets = item.yourTopIntersets;
            this.yourTopIntersets.forEach((element) => {
              element.image = '/assets/icon/' + element.image;
            });

          }
          if (this.isTiedCondition && tabSelectValue === 1) {

            const content = `<p><button (click)="buttonclick()">Submit</button></p>`;
            const modal = this.draggableModalService.show({
              id: 'career-modal',
              class: 'career-modal',
              trayTitle: 'Retake the Assessment',
              initialState: {
                footer: true,
                contentData: this.yourTopIntersets
              },
            });

          }
          if (
            item.yourCareerAssessmentResult &&
            item.yourCareerAssessmentResult.length
          ) {
            this.yourCareerAssessmentResult = item.yourCareerAssessmentResult;
          }
          if (this.yourCareerAssessmentResult) {
            this.buildGraph();
          }

          this.loader = false;
        },
        (err) => {
          this.loader = false;
        }
      );
  }

  retakeAssessment() {
    const content = `
    <p>Are you sure you want to erase your results and retake the Career Assessment?</p>`;
    const modal = this.draggableModalService.show({
      id: 'alert-modal',
      class: 'careerPopup',
      trayTitle: 'Retake the Assessment',
      initialState: {
        content,
        footer: true,
      },
    });
    modal.content.onSubmit.subscribe(() => {
      const localUser = JSON.parse(localStorage.getItem('loginUserData'));
      this.loader = true;
      const jsonData = {
        studentUserid: this.dynamicStudentUserId || localUser.userId,
      };
      this._commonRequestResponseService
        .postWithHeader('student/ResetCareerAssessment', jsonData)
        .subscribe(
          (item: any) => {
            modal.content.hide();
            this.notificationService.show(
              'success',
              'Career Assessment Reset successfully'
            );
            this.getQuestions();
            this.loader = false;
          },
          (err) => {
            this.loader = false;
          }
        );
    });
  }

  launchHes(assessmentType: string) {
    const inputJson: any = {
      userId: this.dynamicStudentUserId,
      partnerId: this.studentPartnerId,
      profileId: this.dynamicStudentProfileId
    };

    let readOnly = false;
    let configurationId: string;
    let assessmentId = '';
    let environment = 'production';

    const hostname = window.location.hostname;
    if (hostname.includes('test')) {
      environment = 'test';
    }

    if (this.role === 'coach') {
      readOnly = true;
    }

    this._commonRequestResponseService
      .getMethod('shared/GetHESUserDetails', inputJson)
      .subscribe(
        (response: any) => {

          if (response) {
            if (assessmentType && assessmentType === 'Learning') {
              configurationId = '101';
              assessmentId = response.learningAssessmentId ? String(response.learningAssessmentId) : '';
            }
            if (assessmentType && assessmentType === 'Personality') {
              configurationId = '104';
              assessmentId = response.personalityAssessmentId ? String(response.personalityAssessmentId) : '';
            }
            if (assessmentType && assessmentType === 'Intelligences') {
              configurationId = '100';
              assessmentId = response.intelligencesAssessmentId ? String(response.intelligencesAssessmentId) : '';
            }
            if (assessmentType && assessmentType === 'Productivity') {
              configurationId = '103';
              assessmentId = response.learningAndProductivityAssessmentId ? String(response.learningAndProductivityAssessmentId) : '';
            }

            const hesPath = `${window.location.origin}/HES_FILE.html?environment=${environment}&configurationId=${configurationId}&userId=${response.hesId}&readOnly=${readOnly ? 'true' : 'false'}&apiToken=${response.hesToken}&assessmentId=${assessmentId}`;
            window.open(hesPath, '_blank');
          }

        },
        (error) => {
          if (error && error.error && error.error.errorMessage) {
            this.notificationService.show('error', error.error.errorMessage);
          } else {
            this.notificationService.show(
              'error',
              'Error while fetching user HES data'
            );
          }
        }
      );
  }

  pinCareer(item) {
    const localUser = JSON.parse(localStorage.getItem('loginUserData'));
    const inputJson = {
      studentProfileID: this.dynamicStudentProfileId || localUser.profileId,
      partnerId: this.studentPartnerId,
      careerClassId: item.id,
      coachComment: '',
      myComment: '',
    };
    this.loader = true;
    if (item.checked) {
      this._commonRequestResponseService
        .postWithHeader('student/unpinCareers', inputJson, ['partnerId'])
        .subscribe(
          () => {
            this.loader = false;
            this.notificationService.show(
              'success',
              'Career unpinned successfully'
            );
            this.getQuestions();
          },
          () => {
            this.loader = false;
            this.notificationService.show('error', 'Error while pining data');
          }
        );
    } else {
      this._commonRequestResponseService
        .postWithHeader('student/pinCareers ', inputJson, ['partnerId'])
        .subscribe(
          () => {
            this.loader = false;
            this.notificationService.show(
              'success',
              'Career pinned successfully'
            );
            this.getQuestions();
          },
          () => {
            this.loader = false;
            this.notificationService.show('error', 'Error while pining data');
          }
        );
    }
  }
  readMoreRedirect(onetSocCode) {
    const locaUserData = JSON.parse(localStorage.getItem('loginUserData'));
    if (locaUserData.module.toLowerCase() === 'student') {
      this.router.navigate(['../careers'], { relativeTo: this.routes });
      localStorage.setItem('careerCode', JSON.stringify(onetSocCode));
      localStorage.setItem('careerActiveRoute', this.currentRoute);
    } else {
      localStorage.setItem('careerCode', onetSocCode);
      this.commonDataSharedService.readMore.next(onetSocCode);
    }
  }

  buildGraph() {
    this.chartDataLabels = [];
    this.chartDataValues = [];
    this.yourCareerAssessmentResult.forEach((data) => {
      this.chartDataLabels.push(data.name.toUpperCase());
      this.chartDataValues.push(data.total);
    });
    if (this.chartDataLabels && this.chartDataValues) {
      this.barGraphs(this.chartDataLabels, this.chartDataValues);
    }
  }

  barGraphs(chartDataLabels: any[], chartDataValues: any[]) {
    this.bar_chart = {
      labels: chartDataLabels,
      datasets: [
        {
          backgroundColor: [
            'rgb(218, 96, 137)',
            'rgb(65, 131, 212)',
            'rgb(239, 181, 102)',
            'rgb(108, 223, 162)',
            'rgb(249, 224, 123)',
            'rgb(162, 91, 196)',
          ],
          data: chartDataValues,
          datalabels: {
            borderColor: [
              'rgb(218, 96, 137)',
              'rgb(65, 131, 212)',
              'rgb(239, 181, 102)',
              'rgb(108, 223, 162)',
              'rgb(249, 224, 123)',
              'rgb(162, 91, 196)',
            ],
            borderWidth: 2,
          },
        },
      ],
    };
    this.options = {
      title: {
        display: false,
      },
      legend: {
        position: 'bottom',
        display: false,
      },
      scales: {
        xAxes: [
          {
            barPercentage: 0.7,
            categoryPercentage: 1.0,
            ticks: {
              beginAtZero: true,
              fontColor: '#68696d',
              fontSize: 24,
              fontStyle: 'bold',
              fontFamily: '"Asul", "Georgia", "Times New Roman", serif',
              padding: 8,
              callback: function (label, index, labels) {
                const result = label.split('');
                return result[0];
              },
            },
            gridLines: {
              lineWidth: 0,
              display: false,
              zeroLineBorderDash: [10, 5],
              zeroLineBorderDashOffset: 8,
              zeroLineWidth: 2,
            },
          },
        ],
        yAxes: [
          {
            ticks: {
              color: '#000',
              beginAtZero: true,
              fontSize: 15,
              stepSize: 5,
              display: false,
              max: 120,
            },
            gridLines: {
              lineWidth: 0,
              display: false,
              zeroLineBorderDash: [10, 5],
              zeroLineBorderDashOffset: 0.8,
              zeroLineWidth: 2,
            },
          },
        ],
      },
      plugins: {
        datalabels: {
          anchor: 'end',
          backgroundColor: '#fff',
          color: '#707071',
          borderRadius: 25,
          font: {
            size: 14,
            family: '"Asul", "Georgia", "Times New Roman", serif',
            weight: '300',
          },
          padding: 8,
        },
      },
    };
  }

  ngOnDestroy() {
    this.careerTabSelectUnsubscribe.unsubscribe();
    this.careerTabSubmitUnsubscribe.unsubscribe();
  }
}
